import React from 'react';
import { mount, route, compose, withView, redirect, map } from 'navi';
import { View } from 'react-navi';
import { PageLayout } from '@zen/common-app-parts';
import MainLayout from './components/layouts/MainLayout';
import PATHS from './paths';
import Commitments from './pages/Commitments/Commitments';

export default mount({
  '/': redirect(PATHS.DEFAULT),
  '/chain-switched': map(() => {
    return redirect(PATHS.DEFAULT);
  }),
  '/app': compose(
    withView(() => (
      <MainLayout>
        <View />
      </MainLayout>
    )),
    mount({
      '/home': compose(
        withView(() => (
          <PageLayout>
            <View />
          </PageLayout>
        )),
        route({
          view: <Commitments />,
        })
      ),
    })
  ),
});
